import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import Datepicker from 'components/Datepicker'
import Modal from 'components/Modal'
import Select from 'components/Select'

import { getOrdersApiParamsConfig } from 'store/Orders/selector'

const MobileFiltersModal = ({
  onCloseModal,
  onChange,
  startDate,
  endDate,
  handleSetFilter,
  statesOptions,
  alphabeticalSortedRevenueCenters,
}) => {
  const { state, standUuid } = useSelector(getOrdersApiParamsConfig)

  return (
    <Modal title="Filters" onClose={onCloseModal}>
      <div className="mobile-filters">
        <Datepicker
          onChange={onChange}
          startDate={startDate}
          endDate={endDate}
          maxDate={new Date()}
          placeholder={'Date/Time Range'}
          dateFormat={'MM/dd/yy'}
          selectsRange={true}
          isOpenButton
        />
        <Select
          id="status"
          handleChange={handleSetFilter('state')}
          nameClass="-medium"
          label="All Status"
          defaultValue={state ?? ''}
          options={statesOptions}
        />
        <Select
          id="revenueCenter"
          handleChange={handleSetFilter('standUuid')}
          nameClass="-medium"
          label="All Revenue Centers"
          defaultValue={standUuid ?? ''}
          options={alphabeticalSortedRevenueCenters}
        />
      </div>
    </Modal>
  )
}

MobileFiltersModal.propTypes = {
  onCloseModal: PropTypes.func,
  onChange: PropTypes.func,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  handleSetFilter: PropTypes.func,
  statesOptions: PropTypes.array,
  alphabeticalSortedRevenueCenters: PropTypes.array,
}

export default MobileFiltersModal
